import * as React from 'react';

function MyBets(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.19 3L3 7.165l5.175 4.183.004-2.668c.184-.005.369-.008.555-.008 2.765-.004 5.257.585 6.934 1.445.839.426 1.466.917 1.843 1.374.38.465.513.852.516 1.227a1.643 1.643 0 01-.23.812c-.24.439-.73.948-1.474 1.417a9.868 9.868 0 01-2.033.952l2.574 2.08c.767-.374 1.458-.81 2.056-1.31.606-.509 1.119-1.088 1.49-1.753.37-.662.591-1.416.59-2.198v-.01c0-1.139-.47-2.194-1.178-3.042-1.076-1.283-2.667-2.213-4.566-2.874-1.902-.654-4.131-1.02-6.522-1.021-.184 0-.367.006-.55.01L8.19 3zm5.758 15.47l-1.408-1.138v-.02l-.02.003-1.72-1.39-.002 1.57a11.73 11.73 0 01-.337.004v-.013c-1.682.002-3.198-.356-4.218-.88-.087-.043-.165-.09-.244-.136l-.032-.018c-.045-.027-.09-.053-.132-.08-1.052-.622-1.7-1.454-1.7-2.37 0-.828.526-1.587 1.4-2.184-.58.281-1.092.618-1.51 1.02-.603.575-1.026 1.334-1.025 2.187-.002.695.284 1.34.717 1.856.653.78 1.622 1.347 2.777 1.748l.023.007-.023.007c1.157.398 2.513.62 3.967.621.112 0 .223-.002.333-.004L10.791 21l3.157-2.53z"
        fill="currentColor"
      />
    </svg>
  );
}

export default MyBets;
